/* eslint-disable max-len */
export const filterConfig = {
  positions: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset', placeholder: 'Select Asset', fieldKey: 'asset', customWidth: 'w-fit',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'totalInvestment', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'dropdown',
      props: {
        status: ['In Profit', 'In Loss'],
        parentKey: 'runningPnL',
        childKey: 'assetValue',
        fieldKey: 'status',
        placeholder: 'Status',
        customWidth: 'w-fit',
        enableRangeFilter: true,
        singleSelectWithRange: true,
        displayMapping: {
          'In Profit': 'Profit',
          'In Loss': 'Loss',
        },
        colorMapping: {
          'In Profit': {
            text: '#39B118',
            bg: '#39B1181A',
          },
          'In Loss': {
            text: 'red',
            bg: '#EF444426',
          },
        },
      },
    },
    { type: 'range', props: { parentKey: 'valueOpenPositions', defaultLabel: 'Value of Open Positions' } },
    {
      type: 'number',
      props: {
        parentKey: 'change', childKey: 'percentage', defaultLabel: 'Change',
      },
    },
    // {
    //   type: 'dropdown',
    //   props: {
    //     keyName: 'direction', placeholder: 'Direction', fieldKey: 'direction', customWidth: 'w-fit',
    //   },
    // },
    // {
    //   type: 'dropdown',
    //   props: {
    //     keyName: 'platform', placeholder: 'Platform', fieldKey: 'platform', customWidth: 'w-fit',
    //   },
    // },
  ],

  closedPositions: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset', placeholder: 'Select Asset', fieldKey: 'asset', customWidth: 'w-fit',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'totalInvestment', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'dropdown',
      props: {
        status: ['In Profit', 'In Loss'],
        parentKey: 'runningPnL',
        childKey: 'assetValue',
        fieldKey: 'status',
        placeholder: 'Status',
        customWidth: 'w-fit',
        enableRangeFilter: true,
        singleSelectWithRange: true,
        displayMapping: {
          'In Profit': 'Profit',
          'In Loss': 'Loss',
        },
        colorMapping: {
          'In Profit': {
            text: '#39B118',
            bg: '#39B1181A',
          },
          'In Loss': {
            text: 'red',
            bg: '#EF444426',
          },
        },
      },
    },
    { type: 'range', props: { parentKey: 'valueOpenPositions', defaultLabel: 'Final Value of closed positions' } },
    { type: 'number', props: { parentKey: 'change', childKey: 'percentage', defaultLabel: 'Change' } },
    // {
    //   type: 'dropdown',
    //   props: {
    //     keyName: 'platform', placeholder: 'Platform', fieldKey: 'platform', customWidth: 'w-fit',
    //   },
    // },
  ],

  swappedPositions: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset', placeholder: 'Select Asset', fieldKey: 'assets', customWidth: 'w-fit',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'totalInvestment', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'dropdown',
      props: {
        status: ['In Profit', 'In Loss'],
        parentKey: 'runningPnL',
        childKey: 'assetValue',
        fieldKey: 'status',
        placeholder: 'Status',
        customWidth: 'w-fit',
        enableRangeFilter: true,
        singleSelectWithRange: true,
        displayMapping: {
          'In Profit': 'Profit',
          'In Loss': 'Loss',
        },
        colorMapping: {
          'In Profit': {
            text: '#39B118',
            bg: '#39B1181A',
          },
          'In Loss': {
            text: 'red',
            bg: '#EF444426',
          },
        },
      },
    },
    { type: 'range', props: { parentKey: 'valueOpenPositions', defaultLabel: 'Final Value of closed positions' } },
    { type: 'number', props: { parentKey: 'change', childKey: 'percentage', defaultLabel: 'Change' } },
    // {
    //   type: 'dropdown',
    //   props: {
    //     keyName: 'platform', placeholder: 'Platform', fieldKey: 'platform', customWidth: 'w-fit',
    //   },
    // },
  ],
  orders: [
    {
      type: 'dropdown',
      props: {
        keyName: 'marketPair', placeholder: 'Select Asset', fieldKey: 'marketPair', customWidth: 'w-fit',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'unitPrice', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    // {
    //   type: 'range',
    //   props: { parentKey: 'quantity', defaultLabel: 'Select Range' },
    // },
    // {
    //   type: 'range',
    //   props: {
    //     parentKey: 'totalPrice', childKey: 'assetValue', defaultLabel: 'Select Range',
    //   },
    // },
    {
      type: 'dropdown',
      props: {
        keyName: 'orderType', placeholder: 'Type', fieldKey: 'orderType', customWidth: 'w-fit',
      },
    },
    // {
    //   type: 'dropdown',
    //   props: {
    //     keyName: 'platform', placeholder: 'Platform', fieldKey: 'platform', customWidth: 'w-[7rem]',
    //   },
    // },
  ],
  markets: [
    {
      type: 'dropdown',
      props: {
        keyName: 'market', placeholder: 'Select Asset', fieldKey: 'markets', customWidth: 'w-fit',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'currentPriceUsd', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'lastBuyPrice', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'lastSellPrice', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'volumeBought', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'volumeSold', childKey: 'assetValue', defaultLabel: 'Select Range',
      },
    },
    { type: 'number', props: { parentKey: 'estimatedProfitPerc', defaultLabel: 'Profit %', multiplyBy100: false } },
  ],
  transfers: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset', placeholder: 'Select Asset', fieldKey: 'assets', customWidth: 'w-fit',
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'type', placeholder: 'Type', fieldKey: 'type', customWidth: 'w-fit',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'amount', childKey: 'grossAssetValue', defaultLabel: 'Select Range',
      },
    },
    // {
    //   type: 'dropdown',
    //   props: {
    //     keyName: 'platform', placeholder: 'Platform', fieldKey: 'platform', customWidth: 'w-[7.275rem]',
    //   },
    // },
  ],
};

export const filterConfigDemo = {
  positionsTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset',
        placeholder: 'Select Asset',
        fieldKey: 'asset',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Asset',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'totalInvestment', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Total Investment', currency: true,
      },
    },
    {
      type: 'dropdown',
      props: {
        status: ['In Profit', 'In Loss'],
        parentKey: 'runningPnL',
        childKey: 'assetValue',
        fieldKey: 'status',
        placeholder: 'Status',
        currency: true,
        customWidth: 'w-[100%]',
        enableRangeFilter: true,
        singleSelectWithRange: true,
        title: 'Current Status',
        displayMapping: {
          'In Profit': 'Profit',
          'In Loss': 'Loss',
        },
        colorMapping: {
          'In Profit': {
            text: '#39B118',
            bg: '#39B1181A',
          },
          'In Loss': {
            text: 'red',
            bg: '#EF444426',
          },
        },
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'valueOpenPositions', defaultLabel: 'Select Range', title: 'Value of Open Positions', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'change', childKey: 'percentage', defaultLabel: 'Change', title: 'Change', multiplyBy100: true,
      },
    },
  ],
  closedPositionsTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset',
        placeholder: 'Select Asset',
        fieldKey: 'asset',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Asset',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'totalInvestment', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Total Investment', currency: true,
      },
    },
    {
      type: 'dropdown',
      props: {
        status: ['In Profit', 'In Loss'],
        parentKey: 'runningPnL',
        childKey: 'assetValue',
        fieldKey: 'status',
        placeholder: 'Status',
        customWidth: 'w-[100%]',
        enableRangeFilter: true,
        singleSelectWithRange: true,
        title: 'Current Status',
        displayMapping: {
          'In Profit': 'Profit',
          'In Loss': 'Loss',
        },
        colorMapping: {
          'In Profit': {
            text: '#39B118',
            bg: '#39B1181A',
          },
          'In Loss': {
            text: 'red',
            bg: '#EF444426',
          },
        },
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'finalValueOfClosedPositions', defaultLabel: 'Select Range', title: 'Final Value of Closed Positions', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'change', childKey: 'percentage', defaultLabel: 'Change', title: 'Change', multiplyBy100: true,
      },
    },
    {
      type: 'dateRange',
      props: {
        keyName: 'closedTime', fieldKey: 'closedTime', title: 'Closed Timestamp',
      },
    },
  ],
  swappedPositionsTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset',
        placeholder: 'Select Asset',
        fieldKey: 'asset',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Asset',
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'totalInvestment', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Total Investment', currency: true,
      },
    },
    {
      type: 'dropdown',
      props: {
        status: ['In Profit', 'In Loss'],
        parentKey: 'runningPnL',
        childKey: 'assetValue',
        fieldKey: 'status',
        placeholder: 'Status',
        customWidth: 'w-[100%]',
        enableRangeFilter: true,
        singleSelectWithRange: true,
        title: 'Current Status',
        displayMapping: {
          'In Profit': 'Profit',
          'In Loss': 'Loss',
        },
        colorMapping: {
          'In Profit': {
            text: '#39B118',
            bg: '#39B1181A',
          },
          'In Loss': {
            text: 'red',
            bg: '#EF444426',
          },
        },
      },
    },
    {
      type: 'range',
      props: {
        parentKey: 'finalValueOfClosedPositions', defaultLabel: 'Select Range', title: 'Final Value of Closed Positions', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        parentKey: 'change', childKey: 'percentage', defaultLabel: 'Change', title: 'Change', multiplyBy100: true,
      },
    },
    {
      type: 'dateRange',
      props: {
        keyName: 'closedTime', fieldKey: 'closedTime', title: 'Closed Timestamp',
      },
    },
  ],
  ordersTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'marketPair',
        placeholder: 'Select Asset',
        fieldKey: 'marketPair',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Market Pair',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'unitPrice', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Unit Price', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'quantity', defaultLabel: 'Select Range', title: 'Quantity', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'totalPrice', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Total Price', currency: true,
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'orderType', placeholder: 'Type', fieldKey: 'orderType', customWidth: 'w-[100%]', title: 'Order Type', currency: true,
      },
    },
    {
      type: 'dateRange',
      props: {
        keyName: 'timestamp', fieldKey: 'timestamp', title: 'Timestamp',
      },
    },
  ],
  walletTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset',
        placeholder: 'Select Asset',
        fieldKey: 'asset',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Assets',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'quantity', defaultLabel: 'Select Range', title: 'Quantity', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'currentPriceUsd', defaultLabel: 'Select Range', title: 'Current Price', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'totalValueUsd', defaultLabel: 'Select Range', title: 'Total Value', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'dollarCostAvg', defaultLabel: 'Select Range', title: 'Dollar Cost Avg', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'percentage', defaultLabel: 'Percentage', title: 'Percentage', multiplyBy100: false,
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'type', placeholder: 'Type', fieldKey: 'type', customWidth: 'w-[100%]', title: 'Type',
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'location', placeholder: 'Location', fieldKey: 'location', customWidth: 'w-[100%]', title: 'Location',
      },
    },
  ],
  coldWalletTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'token',
        placeholder: 'Select Asset',
        fieldKey: 'token',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Token',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'quantity', defaultLabel: 'Select Range', title: 'Quantity', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'currentPriceUsd', defaultLabel: 'Select Range', title: 'Current Price', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'totalValueUsd', defaultLabel: 'Select Range', title: 'Total Value', currency: true,
      },
    },
    // {
    //   type: 'range',
    //   props: {
    //     type: 'number', parentKey: 'dollarCostAvg', defaultLabel: 'Select Range', title: 'Dollar Cost Avg', currency: true,
    //   },
    // },
    // {
    //   type: 'number',
    //   props: {
    //     type: 'percentage', parentKey: 'percentageChange24h', defaultLabel: 'Percentage', title: 'Percentage', multiplyBy100: false,
    //   },
    // },
  ],
  stakingTab: [
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'stakingBalanceInAsset', defaultLabel: 'Select Range', title: 'Staking Balance', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'rewardsEarned', defaultLabel: 'Select Range', title: 'Rewards Earned', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'portfolioPercentage', defaultLabel: 'percentage', title: 'Percentage', multiplyBy100: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'momPercentage', defaultLabel: 'percentage', title: 'MoM Percentage %', multiplyBy100: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'rewardsPerInAsset', defaultLabel: 'Select Range', title: 'Rewards Per In Asset', currency: false,
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'locationPlatform', placeholder: 'Location', fieldKey: 'locationPlatform', customWidth: 'w-[100%]', title: 'Location',
      },
    },
  ],
  performanceTab: [
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'realizedPnL', defaultLabel: 'Select Range', title: 'Realized PnL', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'runningPnL', defaultLabel: 'Select Range', title: 'Running PnL', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'returnRate', defaultLabel: 'percentage', title: 'Percentage', multiplyBy100: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'stakingBalance', defaultLabel: 'Select Range', title: 'Staking Balance', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'earnedRewards', defaultLabel: 'Select Range', title: 'Earned Rewards', currency: true,
      },
    },
  ],
  openOrdersTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'marketPair',
        placeholder: 'Select Asset',
        fieldKey: 'marketPair',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Assets',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'quantity', defaultLabel: 'Select Range', title: 'Quantity', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'limitPrice', childKey: 'usdValue', defaultLabel: 'Select Range', title: 'Price', currency: true,
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'orderType', placeholder: 'Select Type', fieldKey: 'orderType', customWidth: 'w-[100%]', title: 'Type', currency: false,
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'status', placeholder: 'Select Status', fieldKey: 'status', customWidth: 'w-[100%]', title: 'Status', currency: false,
      },
    },
    {
      type: 'dateRange',
      props: {
        keyName: 'timestamp', fieldKey: 'timestamp', title: 'Timestamp',
      },
    },
  ],
  marketTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'market',
        placeholder: 'Select Asset',
        fieldKey: 'market',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Assets',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'currentPriceUsd', defaultLabel: 'Select Range', title: 'Current Price', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'lastBuyPrice', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Last Buy Price', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'lastSellPrice', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Last Sell Price', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', fieldKey: 'quantityBought', parentKey: 'quantity', childKey: 'bought', defaultLabel: 'Select Range', title: 'Quantity Bought', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', fieldKey: 'quantitySold', parentKey: 'quantity', childKey: 'sold', defaultLabel: 'Select Range', title: 'Quantity Sold', currency: false,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'volumeBought', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Volume Bought', currency: true,
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'volumeSold', childKey: 'assetValue', defaultLabel: 'Select Range', title: 'Volume Sold', currency: true,
      },
    },
    {
      type: 'number',
      props: {
        type: 'percentage', parentKey: 'estimatedProfitPerc', defaultLabel: 'Profit %', title: 'Estimated Profit', multiplyBy100: false,
      },
    },
  ],
  transfersTab: [
    {
      type: 'dropdown',
      props: {
        keyName: 'asset',
        placeholder: 'Select Asset',
        fieldKey: 'asset',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Assets',
      },
    },
    {
      type: 'dropdown',
      props: {
        keyName: 'type',
        placeholder: 'Select Type',
        fieldKey: 'type',
        customWidth: 'w-[100%]',
        dropdownWidth: 'w-[230px]',
        popoverWidth: 350,
        dropdownMaxHeight: 'max-h-96',
        popoverContentWidth: 'w-[320px]',
        customHeight: 'h-[100%]',
        title: 'Type',
      },
    },
    {
      type: 'range',
      props: {
        type: 'number', parentKey: 'amount', childKey: 'grossAssetValue', defaultLabel: 'Select Range', title: 'Amount', currency: true,
      },
    },
    {
      type: 'dateRange',
      props: {
        keyName: 'timestamp', fieldKey: 'timestamp', title: 'Timestamp',
      },
    },
  ],
};
